import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadDocFileUpload } from './components/UploadDocFileUpload';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import NoticeModal from '../../DesignSystem/NoticeModal/NoticeModal';
import { ReactComponent as SuccessIcon } from '../../assets/icons/svg/colored-icons/ic-colored-success-new.svg';
import { ReactComponent as Failure } from '../../assets/icons/svg/colored-icons/ic-colored-failure-new.svg';
import { useUploadMissingDoc } from './hooks/useUploadMissingDoc';
import { useSaveMissingDoc } from './hooks/useSaveMissingDoc';
import { useStore } from '../../store';

interface UploadDocFileUploadProps {
    onClose: () => void;
    onSuccess: () => void;
}
export const UploadDocFlow = ({ onClose, onSuccess } : UploadDocFileUploadProps) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const userData = useStore(state => state.getSummaryData());
  const { mutateAsync: uploadMissingDoc, isLoading } = useUploadMissingDoc((error: string) => setErrorMessage(error));
  const { mutateAsync: mutateSaveMissingDoc, isLoading: isSavingDoc } = useSaveMissingDoc((code: number, error: string) => setErrorMessage(error));
  enum FormState {
        FILE_UPLOAD, SUCCESS, ERROR
    }
  const [flowState, setFormState] = useState<FormState>(FormState.FILE_UPLOAD);

  useEffect(() => {
    if (errorMessage) {
      setFormState(FormState.ERROR);
    }
  }, [errorMessage]);

  const saveMissingDocs = (token: string) => {
    mutateSaveMissingDoc({
      businessId: userData.business.externalId,
      businessType: userData.business.type,
      documentTokens: [token],
    }).then(() => {
      setFormState(FormState.SUCCESS);
      onSuccess();
    });
  };
  const handleFileSubmit = (file: File) => {
    if (!file) {
      return;
    }
    uploadMissingDoc({ file })
      .then((token) => {
        saveMissingDocs(token);
      });
  };
  if (flowState === FormState.SUCCESS) {
    return (
      <NoticeModal
        title={t('UPLOAD_EIN_DOC.SUCCESS.TITLE')}
        id='file-upload-success-modal'
        image={(<SuccessIcon />)}
        content={(<p className='text-[16px] text-bw08 font-metricR text-center mb-[32px]'>{t('UPLOAD_EIN_DOC.SUCCESS.SUBTITLE')}</p>)}
        buttonText={t('UPLOAD_EIN_DOC.SUCCESS.CTA')}
        onSubmit={onClose}
        onClickOutside={onClose}
      />
    );
  }
  if (flowState === FormState.ERROR) {
    return (
      <NoticeModal
        title={t('UPLOAD_EIN_DOC.ERROR.TITLE')}
        id='file-upload-success-modal'
        image={(<Failure />)}
        content={(<p className='text-[16px] text-bw08 font-metricR text-center mb-[32px]'>{t('UPLOAD_EIN_DOC.ERROR.SUBTITLE')}</p>)}
        buttonText={t('UPLOAD_EIN_DOC.ERROR.CTA')}
        onSubmit={onClose}
        onClickOutside={onClose}
      />
    );
  }
  return (
    <UserMessage onClick={onClose} id=''>
      <div className='w-full  h-full fixed'>
        <div className='absolute z-[99999] flex items-center justify-center w-full  h-full overflow-y-scroll animate-fadeIn'>
          <UploadDocFileUpload onSubmit={handleFileSubmit} onClose={onClose} isLoading={isLoading || isSavingDoc} />
        </div>
      </div>
    </UserMessage>

  );
};
